  
  // Adp Discount Pop Up
  var wholesaleDiscountBtn = $('.wholesale-discount-btn');
  var wholesaleDiscountOverlay = $('.adp-discount-overlay');
  var wholesaleDiscountWrapper = $('.template-main-product');
  var wholesaleDiscountClose = $('.adp-discount-close');

  wholesaleDiscountBtn.on('click', function() {
    wholesaleDiscountWrapper.addClass('is-visible');
    $('body').addClass('adp-discount-open');
    var wholesaleDiscountTop = $('.adp-discount-tiers').position().top + 20;
    var wholesaleDiscountRight = $('.adp-discount-tiers').position().left + 20;
    wholesaleDiscountClose.css('top', wholesaleDiscountTop);
    wholesaleDiscountClose.css('right', wholesaleDiscountRight);
  });
  
  wholesaleDiscountOverlay.on('click', function() {
    wholesaleDiscountWrapper.removeClass('is-visible');
    $('body').removeClass('adp-discount-open');
  });
  
  wholesaleDiscountClose.on('click', function() {
    wholesaleDiscountWrapper.removeClass('is-visible');
    $('body').removeClass('adp-discount-open');
  });



    $(document).ready(function () {
        function SizechartshowPopup() {
            $(".custom_sizechart_overlay").addClass("active");
            $(".custom_sizechart_popup").addClass("active");
            $("body").css("overflow-y","hidden");
        }

        function SizecharthidePopup() {
            $(".custom_sizechart_overlay").removeClass("active");
            $(".custom_sizechart_popup").removeClass("active");
            $("body").css("overflow-y","auto");
        }

        $(".custom_sizechart_overlay, .custom_sizechart_popup-close").on("click", function () {
            SizecharthidePopup(); 
        });
        $(".custom_sizechart_btn").click(function(e){
          e.preventDefault();
          SizechartshowPopup();
        });
      
    });

   $(document).ready(function () {
        function CarechartshowPopup() {
            $(".custom_carechart_overlay").addClass("active");
            $(".custom_carechart_popup").addClass("active");
            $("body").css("overflow-y","hidden");
        }

        function CarecharthidePopup() {
            $(".custom_carechart_overlay").removeClass("active");
            $(".custom_carechart_popup").removeClass("active");
            $("body").css("overflow-y","auto");
        }

        $(".custom_carechart_overlay, .custom_carechart_popup-close").on("click", function () {
            CarecharthidePopup(); 
        });
        $(".custom_care__btn").click(function(e){
          e.preventDefault();
          CarechartshowPopup();
        });
      
    });

  $(document).ready(function () {
        function EmbroiderychartshowPopup() {
            $(".custom_embroidery_overlay").addClass("active");
            $(".custom_embroidery_popup").addClass("active");
            $("body").css("overflow-y","hidden");
            
        }

        function EmbroiderycharthidePopup() {
            $(".custom_embroidery_overlay").removeClass("active");
            $(".custom_embroidery_popup").removeClass("active");
            $("body").css("overflow-y","auto");
        }

        $(".custom_embroidery_overlay, .custom_embroidery_popup-close").on("click", function () {
            EmbroiderycharthidePopup(); 
            $(".sticky-header").css("z-index","1000");
        });
        $(".product-personalize-link").click(function(e){
          e.preventDefault();
          EmbroiderychartshowPopup();
          $(".sticky-header").css("z-index","0");
        });
      
    });

  

